module.exports = __webpack_public_path__ + "media/images/beta-e81f786300900d560defb067c45fd185.png";